module.exports = "<button mat-icon-button (click)=\"toggleScreen()\" class=\"fill-screen-button\">\n    <mat-icon *ngIf=\"!isEnlarged\" aria-label=\"Enlarge graph\">fullscreen</mat-icon>\n    <mat-icon *ngIf=\"isEnlarged\" aria-label=\"Enlarge graph\">fullscreen_exit</mat-icon>\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/chart/barchart/data.graph.component.html
// module id = 1063
// module chunks = 0